/**
 * @author       julian@zumper.com (Julian Napolitan)
 * @copyright    Copyright (c) 2020, Zumper
 * @description  schema.ts
 */

import { type PayloadAction, createSlice } from '@reduxjs/toolkit'
import type { Listable } from '@zcode/state-type'

import type { ResultDataType } from '../../components/Calculator/types'

interface Meta {
  fetchingKey: string | null
}

interface SchemaType {
  listables: readonly Listable[]
  meta: Meta
  countsBy?: any
  countsByFetching: boolean
  results?: ResultDataType
}

export const AffordabilityCalculatorSchema: SchemaType = {
  listables: [],
  meta: {
    fetchingKey: null,
  },
  countsBy: undefined,
  countsByFetching: false,
  results: undefined,
}

const affordabilityCalculatorSlice = createSlice({
  name: 'affordabilityCalculator',
  initialState: AffordabilityCalculatorSchema,
  reducers: {
    clearFetchingKey: (state: SchemaType) => {
      state.meta.fetchingKey = null
    },
    receiveListables: (state: SchemaType, action: PayloadAction<readonly Listable[]>) => {
      state.listables = action.payload
    },
    receiveResults: (state: SchemaType, action: PayloadAction<ResultDataType>) => {
      state.results = action.payload
    },
    setFetchingKey: (state: SchemaType, action: PayloadAction<string>) => {
      state.meta.fetchingKey = action.payload
    },
    setCountsBy: (state: SchemaType, action: PayloadAction<any>) => {
      state.countsBy = action.payload
    },
    setCountsByFetching: (state: SchemaType, action: PayloadAction<boolean>) => {
      state.countsByFetching = action.payload
    },
  },
})

export const { actions, reducer } = affordabilityCalculatorSlice
